import { render, staticRenderFns } from "./SmsContactListItemV2.vue?vue&type=template&id=77804479&scoped=true&"
import script from "./SmsContactListItemV2.vue?vue&type=script&lang=js&"
export * from "./SmsContactListItemV2.vue?vue&type=script&lang=js&"
import style0 from "./scoped.scss?vue&type=style&index=0&id=77804479&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77804479",
  null
  
)

export default component.exports